import React from "react";
import { string, number, bool, shape } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomText from "pages/_components/CustomText/CustomText";
import Button from "pages/_components/Button";
import gaEventTracker, { events } from "util/gaEventTracker";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";

const MovementDetailList = ({ ...props }) => {
    const { isDesktop, movement, account, dispatch } = props;

    const handleDownloadClick = () => {
        gaEventTracker.triggerEvent(events.cuentas_detalle_movimientos_descargar());
        dispatch(accountsActions.downloadMovement(movement, "pdf"));
    };

    return (
        <div className={!isDesktop ? "d-flex flex-column justify-between mt-9" : null}>
            <GridTable className="movement-details-list">
                <GridTable.Container key={movement.idProduct}>
                    <GridTable.Data columnStart={1} rowStart={1} alignY="flex-start">
                        <CustomData
                            titleText="accounts.movement.detail.date"
                            titleTextType="I18N"
                            valueText={movement.date}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2} alignY="flex-start">
                        <CustomData
                            titleText="accounts.movement.detail"
                            titleTextType="I18N"
                            valueText={movement.detail}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3} alignY="flex-start">
                        <CustomData
                            titleText="accounts.movement.detail.reference"
                            titleTextType="I18N"
                            valueText={movement.reference}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 4 : 1} rowStart={isDesktop ? 1 : 4} alignY="flex-start">
                        <div className="custom-data">
                            <CustomText
                                text="accounts.movement.detail.amount"
                                textType="I18N"
                                className="custom-data-title"
                            />
                            <FormattedAmount
                                className={`custom-data-value data-amount data-amount-${
                                    movement.credit ? "credit" : "debit"
                                }`}
                                currency={account.currency}
                                quantity={movement.credit || movement.debit}
                            />
                        </div>
                    </GridTable.Data>
                    {/* <GridTable.Data columnStart={isDesktop ? 1 : 1} rowStart={isDesktop ? 2 : 4} alignY="flex-start">
                        <CustomData
                            titleText="accounts.movement.detail.channel"
                            titleTextType="I18N"
                            valueText={movement.channel}
                        />
                    </GridTable.Data> */}
                </GridTable.Container>
            </GridTable>
            {!isDesktop && (
                <Button
                    className="btn-primary mt-9"
                    onClick={handleDownloadClick}
                    image="images/download-figma.svg"
                    label="global.download"
                />
            )}
        </div>
    );
};

MovementDetailList.propTypes = {
    isDesktop: bool.isRequired,
    account: shape({
        currency: string.isRequired,
    }).isRequired,
    movement: shape({
        depositTypeNum: string.isRequired,
        expiration: number.isRequired,
        chargeAmount: number,
        capitalInvested: number.isRequired,
        tna: number,
        interestGained: number,
        creationDate: number,
        termInDays: number,
        autoRenewal: string,
        anticipatedCancelation: bool,
        currency: string,
    }).isRequired,
};

MovementDetailList.defaultProps = {};

export default MovementDetailList;
